import { render, staticRenderFns } from "./PostRank.vue?vue&type=template&id=186fcde7&scoped=true"
import script from "./PostRank.vue?vue&type=script&lang=js"
export * from "./PostRank.vue?vue&type=script&lang=js"
import style0 from "./PostRank.vue?vue&type=style&index=0&id=186fcde7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186fcde7",
  null
  
)

export default component.exports